import { ResetPasswordVerifyOtpApiNamespace } from '@core/models/api';

export namespace ResetPasswordVerifyOtpNamespace {
  export interface IN {
    requestKey: string;
    otp: string;
    recaptchaToken: string;
  }

  export class OUT {
    accessToken: string = '';
    expiresAt: number = 0;

    constructor() {}

    init(input: ResetPasswordVerifyOtpApiNamespace.OUT) {
      this.accessToken = input.accessToken;
      this.expiresAt = input.expiresIn;

      return this;
    }
  }
}
